import { render } from "./LunarNewYear.vue?vue&type=template&id=155dadc8&scoped=true"
import script from "./LunarNewYear.vue?vue&type=script&lang=js"
export * from "./LunarNewYear.vue?vue&type=script&lang=js"

import "./LunarNewYear.vue?vue&type=style&index=0&id=155dadc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155dadc8"]])

export default __exports__